import bar from '../charts/bar'

export default () => {
    const charts = document.querySelectorAll('[data-chart]')

    charts.forEach(chart => {
        initializeCharts(chart)
    })
}

const initializeCharts = (chart) => {
    const chartType = chart.dataset.chart

    if (chartType === 'bar') {
        bar(chart)
    }
}

export const settings = {
    legend: {
        position: 'bottom',
        labels: {
          padding: 32,
          font: {
            size: 16,
            family: "DIN Pro, system-ui",
          },
          boxWidth: 16,
          boxHeight: 16,   
          filter: function(legendItem, chartData) {
            return chartData.datasets[legendItem.datasetIndex].type !== 'bubble';
          },
        },   
      }   
}
